import { ClientsTable } from './clients.table';


// Wrapper class
export class SaasDataContext {
	public static clients: any = ClientsTable.clients;
}
